import { type FC, useState } from 'react';

import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useShareToken } from '@/features/admin-interview';
import { type CandidateBasicDto } from '@/services/api';

import { IconPhone } from '../../components/Icons';
import { CallCandidatesConfirmationModal } from './CallCandidatesConfirmationModal';

type CallCandidatesProps = {
  selectedCandidates: Array<CandidateBasicDto>;
  totalCandidates: number;
  interviewId?: string;
  onClearSelection: () => void;
};

export const CallCandidates: FC<CallCandidatesProps> = ({
  selectedCandidates,
  totalCandidates,
  interviewId,
  onClearSelection,
}: CallCandidatesProps) => {
  const shareToken = useShareToken();
  const { t } = useTranslation(['candidate']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const count = selectedCandidates.length;

  return (
    <>
      {count !== 0 && (
        <Button
          onClick={() => setIsModalOpen(true)}
          leftIcon={<IconPhone fontSize="xl" color="gray.600" />}
          isDisabled={!!shareToken || totalCandidates === 0}
          size="md"
          px={3}
          variant="unstyled"
          w="full"
          textAlign="left"
          _hover={{ bg: 'gray.50' }}
          borderRadius={0}
        >
          {t('candidate:inviteNewCandidate.callCandidates', {
            count,
          })}
        </Button>
      )}

      <CallCandidatesConfirmationModal
        isOpen={isModalOpen}
        onClose={() => {
          onClearSelection();
          setIsModalOpen(false);
        }}
        interviewId={interviewId ?? ''}
        selectedCandidates={selectedCandidates}
      />
    </>
  );
};
